import Switch from '@mui/material/Switch';
import React from 'react';

import { useProfileUpdate } from '../../../hooks';

/**
 * Used for Switch settings in the Profile. Not reusable outside of the profile
 * at this time, but could be refactored to use a general Switch component.
 */

const ProfileSwitchSetting = ({
  userId,
  value,
  sanitizedFieldName,
  description,
  hint,
  hasOppositeValue, // because mentioning_disabled column in db asks if they want mentioning enabled
}) => {
  const { saveProfile, showSave } = useProfileUpdate(userId);

  const checkedValue = hasOppositeValue ? !value : value;
  return (
    <div className="ProfileSwitchSetting">
      <div className="section-detail-container">
        {showSave && <div className="save-label success">Saved</div>}
        <div className="section-description">{description}</div>
        <Switch
          id={sanitizedFieldName}
          checked={checkedValue}
          onChange={() => saveProfile({ [sanitizedFieldName]: !value })}
        />
      </div>
      <div className="hint">{hint}</div>
    </div>
  );
};

export default ProfileSwitchSetting;
